import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'ca-animated-category',
  styleUrls: ['./animated-category.component.scss'],
  templateUrl: 'animated-category.component.html',
})
export class EasterCategoryComponent {
  constructor() {}

  _isSelected = false;
  _category: { id: string; name: string };
  public animate = false;
  public animation: AnimationOptions;

  @Output() toggleEvent = new EventEmitter<void>();

  @Input()
  set category(data: { id: string; name: string }) {
    if (!data) {
      return;
    }
    this._category = data;
    this.animation = {
      path: `assets/lottie/categories/${data.name}.json`,
      loop: false,
      autoplay: false,
    };
  }

  @Input() set selected(data: boolean) {
    if (data == null) {
      return;
    }
    this._isSelected = data;
  }

  get selected() {
    return this._isSelected;
  }

  // :Note: We don't get a 'play animation' callback for lottie, but we can
  // update the animation settings, causing a refresh that doesn't loop.
  playEasterAnimation(): void {
    this.animation = {
      ...this.animation,
      autoplay: true,
      loop: false,
    };
  }

  toggle(): void {
    if (!this.selected) {
      this.playEasterAnimation();
    }
    this.animate = !this.selected;
    this.toggleEvent.emit();
  }
}
